/**
 * https://github.com/github/fetch#handling-http-error-statuses
 * This is from the github documentation. It will check response status and throw an error if necessary
 * This is because of the fetch polyfill has some differences with native fetch
 */
const checkResponseStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};

export default checkResponseStatus;
